import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { Config, PriceList, ReactiveSource } from '../@types/editor'

import { type EditorPlay, usePickLotteryStore } from '../stores/pickLottery'
import {
  getMaxWagerValue,
  getMinWagerValue,
  getPreparedWagers,
  getWagerMarker,
} from '../utils/editorWager'

export const usePickLotteryWager = (
  lotteryId: LotteryId,
  configRef: ReactiveSource<Config>,
  priceListRef: ReactiveSource<PriceList>,
  playRef: ReactiveSource<EditorPlay>,
) => {
  const { setStake } = usePickLotteryStore(lotteryId)

  const config = computed(() => toValue(configRef))
  const priceList = computed(() => toValue(priceListRef))
  const play = computed(() => toValue(playRef))

  const preparedWagers = computed(() => getPreparedWagers(config.value, priceList.value))

  const max = computed(() => getMaxWagerValue(preparedWagers.value))

  const min = computed(() => getMinWagerValue(preparedWagers.value))

  const marker = computed(() => getWagerMarker(preparedWagers.value))

  const selectedStake = computed(
    () => preparedWagers.value.find(({ id }) => id === play.value.stake)?.value ?? min.value,
  )

  const handleSetStake = (value?: number) => {
    const wager = preparedWagers.value.find((wager) => wager.value === value)
    if (!wager) return
    setStake(play.value.id, wager.id)
  }

  return { handleSetStake, marker, max, min, selectedStake }
}
